import { render, staticRenderFns } from "./UtilizationWidget.vue?vue&type=template&id=497e9cab&scoped=true"
import script from "./UtilizationWidget.vue?vue&type=script&setup=true&lang=ts"
export * from "./UtilizationWidget.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./UtilizationWidget.vue?vue&type=style&index=0&id=497e9cab&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "497e9cab",
  null
  
)

export default component.exports